import angular from 'angular';

import NotificationToastItem from './notification-toast-item/notification-toast-item.component';
import NotificationToastWrap from './notification-toast-wrap/notification-toast-wrap.component';

const DEPENDENCIES = [
  NotificationToastItem,
  NotificationToastWrap,
];

export default angular.module('autoboard.notificationToast', DEPENDENCIES)
  .name;
